export const trimValues = (values: any) => {
  const trimmedValues = Object.keys(values).reduce((acc: any, key) => {
    acc[key] =
      typeof values[key] === "string" ? values[key].trim() : values[key];
    return acc;
  }, {});
  return trimmedValues;
};
